import { i18n } from '@fs/zion-locale'
import { baseUrl } from '@fs/zion-config'

import { cleanUpNotes, findPropertyValue } from 'helpers'
import { formattedYearRange } from 'helpers/dateUtils'
import DownloadCsvConfig from './DownloadCsvConfig'

export default class JokboCsv extends DownloadCsvConfig {
  static columns = [
    { key: 'title', header: i18n.t('JokboCsv.header.title', 'Title') },
    { key: 'titleNumber', header: i18n.t('JokboCsv.header.titleNumber', 'Title Number') },
    { key: 'groupId', header: i18n.t('JokboCsv.header.groupId', 'Group ID') },
    { key: 'surnames', header: i18n.t('JokboCsv.header.surname', 'Surname') },
    { key: 'clans', header: i18n.t('JokboCsv.header.clan', 'Clan') },
    { key: 'clanBranches', header: i18n.t('JokboCsv.header.clanBranch', 'Clan Branch') },
    { key: 'places', header: i18n.t('JokboCsv.header.place', 'Place') },
    { key: 'date', header: i18n.t('JokboCsv.header.date', 'Date') },
    { key: 'publicationDate', header: i18n.t('JokboCsv.header.publicationDate', 'Publication Date') },
    { key: 'volumeCount', header: i18n.t('JokboCsv.header.volumeCount', 'Volume Count') },
    { key: 'volumes', header: i18n.t('JokboCsv.header.volume', 'Volume') },
    { key: 'imageCount', header: i18n.t('JokboCsv.header.imageCount', 'Image Count') },
    { key: 'ancestors', header: i18n.t('JokboCsv.header.ancestors', 'First Ancestors') },
    { key: 'authors', header: i18n.t('JokboCsv.header.author', 'Author') },
    { key: 'titleNotes', header: i18n.t('JokboCsv.header.notes', 'Notes') },
    { key: 'url', header: i18n.t('JiapuCsv.header.url', 'URL') },
  ]

  static filename = i18n.t('JokboCsv.filename.searchResults', 'searchResults')

  generateRows(groups) {
    groups.forEach((group) => {
      this.rows.push({
        ancestors: group.ancestors?.join(', '),
        authors: group.authors?.join(', '),
        clanBranches: group.clanBranches?.join(', ') || group.clanBranch,
        clans: group.clans?.join(', '),
        date: formattedYearRange([group.yearRange?.fromYear, group.yearRange?.toYear]),
        groupId: group.id,
        imageCount: group.childCount,
        places: [...new Set(group.coverages?.map((coverage) => coverage.place?.fullName))].filter(Boolean).join('; '),
        publicationDate: group.publicationDate,
        surnames: group.surnames?.join(', '),
        title: group.volumeSetTitle,
        titleNotes: cleanUpNotes(group.titleNotes).join(', '),
        titleNumber: group.titleNumber,
        url: `${baseUrl}/records/images/redirect/${group.id}`,
        volumes: findPropertyValue('volume', group.properties),
        volumeCount: group.childGroupCount,
      })
    })
  }
}
